/* @jsxImportSource react */

import type { ReactNode } from 'react';

import { Link } from '../../../Link/Link';

/**
 * Simplified version of the legacy Slot, for cases where the slot just needs to be a link
 *
 * @param children The icon for the slot, should be sized 32x32 pixels (w-4 h-4)
 * @param label The text label (and accessible label) for the slot
 * @param href The URL to link to
 */
export const SlotLink = ({
  label,
  href,
  children,
}: {
  label: string;
  href: string;
  children: ReactNode;
}) => (
  <Link
    href={href}
    aria-label={label}
    className="hover:text-color-primary hover:after:bg-color-primary relative flex flex-col items-center py-0.5 hover:after:pointer-events-none hover:after:absolute hover:after:inset-0 hover:after:top-auto hover:after:h-[2px]"
  >
    {children}
    <span className="text-size-body3 text-color-text text-center max-lg:hidden">{label}</span>
  </Link>
);
